<div class="users-section">
  <mat-expansion-panel
    class="users-expansion-panel"
    hideToggle="true"
    [expanded]="isExpanded"
    (opened)="onExpanded()"
    (closed)="onCollapsed()"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon
          class="expansion-indicator"
          [class.expanded]="isExpanded"
          [style.transform]="isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)'"
          [style.transition]="'transform 0.25s ease-in-out'"
          >expand_more</mat-icon
        >
        <span class="panel-title-group">
          <span class="panel-title-text">{{ title }}</span>
          @if (!isLoading) {
            <span class="panel-title-count">({{ getTotalAssigned() }})</span>
          }
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    @if (isLoading) {
      <div class="loading-state">
        <mat-spinner diameter="32"></mat-spinner>
        <p>Loading resources...</p>
      </div>
    } @else {
      <div class="users-content">
        <div class="search-assign-container">
          <!-- Assigned resources -->
          <div class="assigned-section">
            <h5 class="section-title">Assigned Resources</h5>

            <div style="display: flex">
              <mat-form-field
                appearance="outline"
                class="search-field"
                style="flex: 1"
              >
                <mat-label>Search assigned resources</mat-label>
                <input
                  matInput
                  [(ngModel)]="assignedSearchQuery"
                  placeholder="Filter assigned resources..."
                  (input)="onAssignedSearch()"
                />
                <mat-icon
                  matSuffix
                  [style.cursor]="assignedSearchQuery ? 'pointer' : 'default'"
                  (click)="clearAssignedSearch()"
                  >{{ assignedSearchQuery ? "clear" : "search" }}</mat-icon
                >
              </mat-form-field>
              <div style="flex: 1"></div>
            </div>

            <div
              class="assigned-users-list"
              [class.no-pagination]="getTotalAssigned() === 0"
            >
              <div class="assigned-search-results-header">
                <p>
                  {{
                    assignedSearchQuery.trim()
                      ? 'Assigned resources matching "' +
                        assignedSearchQuery +
                        '":'
                      : "All assigned resources:"
                  }}
                </p>
              </div>
              @if (getTotalAssigned() === 0) {
                <div class="empty-assigned">
                  <p>No resources assigned yet</p>
                </div>
              } @else {
                @for (user of getAssignedRows(); track user.employeeId) {
                  <div
                    class="assigned-user-item"
                    [class.newly-added]="isNewlyAdded(user)"
                    [class.loading]="isRowLoading(user)"
                    [class.sync-locked]="!isRemovable(user)"
                    (click)="
                      canManage &&
                        isRemovable(user) &&
                        !isRowLoading(user) &&
                        remove(user)
                    "
                  >
                    <div class="user-info">
                      <span class="user-name"
                        >{{ user.firstName }} {{ user.lastName }}</span
                      >
                      <span class="user-email">{{ user.email }}</span>
                    </div>
                    <div class="assigned-user-trailing">
                      <span
                        class="membership-badge"
                        [class.membership-badge--primary]="!isRemovable(user)"
                        [class.membership-badge--secondary]="isRemovable(user)"
                      >
                        {{ isRemovable(user) ? "Secondary" : "Primary" }}
                      </span>
                      @if (isRowLoading(user)) {
                        <mat-spinner
                          diameter="20"
                          class="loading-spinner"
                        ></mat-spinner>
                      } @else if (!isRemovable(user)) {
                        <mat-icon
                          class="sync-lock-icon"
                          [matTooltip]="dataSource.lockedTooltip"
                          matTooltipPosition="above"
                          >lock</mat-icon
                        >
                      } @else if (canManage) {
                        <mat-icon class="remove-icon">remove_circle</mat-icon>
                      }
                    </div>
                  </div>
                }
              }
            </div>

            @if (getTotalAssigned() > 0) {
              <mat-paginator
                [length]="getTotalAssigned()"
                [pageSize]="assignedPageSize"
                [pageIndex]="assignedPageIndex"
                [pageSizeOptions]="[5, 10, 25, 50]"
                (page)="onAssignedPageChange($event)"
                showFirstLastButtons="true"
                class="user-list-paginator"
              >
              </mat-paginator>
            }
          </div>

          <!-- Add resources -->
          @if (canManage) {
            <div class="search-section">
              <h5 class="section-title">Add Resources</h5>

              <div style="display: flex">
                <mat-form-field
                  appearance="outline"
                  class="search-field"
                  style="flex: 1"
                >
                  <mat-label>Search resources to add</mat-label>
                  <input
                    matInput
                    [(ngModel)]="addSearchQuery"
                    placeholder="Type to search..."
                    (input)="onAddSearch($event)"
                  />
                  <mat-icon
                    matSuffix
                    [style.cursor]="addSearchQuery ? 'pointer' : 'default'"
                    (click)="clearAddSearch()"
                    >{{ addSearchQuery ? "clear" : "search" }}</mat-icon
                  >
                </mat-form-field>
                <div style="flex: 1"></div>
              </div>

              <div
                class="search-results"
                [class.has-recently-removed]="
                  !addSearchQuery.trim() && getAllRecentlyRemoved().length > 0
                "
                [class.empty-state]="
                  !addSearchQuery.trim() && getAllRecentlyRemoved().length === 0
                "
                [class.has-search-results]="addSearchQuery.trim()"
              >
                @if (addSearchQuery.trim()) {
                  <div class="search-results-header">
                    <p>Search results for "{{ addSearchQuery }}":</p>
                  </div>
                  @if (getSearchResults().length > 0) {
                    @for (user of getSearchResults(); track user.employeeId) {
                      <div
                        class="search-result-item"
                        [class.loading]="isRowLoading(user)"
                        (click)="!isRowLoading(user) && add(user)"
                        [title]="
                          isRowLoading(user)
                            ? 'Processing...'
                            : 'Click to add ' +
                              user.firstName +
                              ' ' +
                              user.lastName
                        "
                      >
                        <div class="user-info">
                          <span class="user-name"
                            >{{ user.firstName }} {{ user.lastName }}</span
                          >
                          <span class="user-email">{{ user.email }}</span>
                        </div>
                        @if (isRowLoading(user)) {
                          <mat-spinner
                            diameter="20"
                            class="loading-spinner"
                          ></mat-spinner>
                        } @else {
                          <mat-icon class="add-icon">add_circle</mat-icon>
                        }
                      </div>
                    }
                  } @else {
                    <div class="no-results">
                      <p>No resources found matching "{{ addSearchQuery }}"</p>
                    </div>
                  }
                } @else {
                  @if (getTotalRecentlyRemoved() > 0) {
                    <div class="recently-removed-header">
                      <p>Recently removed resources:</p>
                    </div>
                    @for (
                      user of getPaginatedRecentlyRemoved();
                      track user.employeeId
                    ) {
                      <div
                        class="search-result-item recently-removed"
                        [class.loading]="isRowLoading(user)"
                        (click)="!isRowLoading(user) && add(user)"
                        [title]="
                          isRowLoading(user)
                            ? 'Processing...'
                            : 'Click to add ' +
                              user.firstName +
                              ' ' +
                              user.lastName
                        "
                      >
                        <div class="user-info">
                          <span class="user-name"
                            >{{ user.firstName }} {{ user.lastName }}</span
                          >
                          <span class="user-email">{{ user.email }}</span>
                        </div>
                        @if (isRowLoading(user)) {
                          <mat-spinner
                            diameter="20"
                            class="loading-spinner"
                          ></mat-spinner>
                        } @else {
                          <mat-icon class="add-icon">add_circle</mat-icon>
                        }
                      </div>
                    }
                  } @else {
                    <div class="search-prompt">
                      <p>Start typing to search for resources...</p>
                    </div>
                  }
                }
              </div>

              @if (!addSearchQuery.trim() && getTotalRecentlyRemoved() > 0) {
                <mat-paginator
                  [length]="getTotalRecentlyRemoved()"
                  [pageSize]="recentlyRemovedPageSize"
                  [pageIndex]="recentlyRemovedPageIndex"
                  [pageSizeOptions]="[5, 10, 25, 50]"
                  (page)="onRecentlyRemovedPageChange($event)"
                  showFirstLastButtons="true"
                  class="recently-removed-paginator"
                >
                </mat-paginator>
              }
              @if (addSearchQuery.trim() && getTotalSearchResults() > 0) {
                <mat-paginator
                  [length]="getTotalSearchResults()"
                  [pageSize]="searchPageSize"
                  [pageIndex]="searchPageIndex"
                  [pageSizeOptions]="[5, 10, 25, 50]"
                  (page)="onSearchPageChange($event)"
                  showFirstLastButtons="true"
                  class="search-results-paginator"
                >
                </mat-paginator>
              }
            </div>
          }
        </div>
      </div>
    }
  </mat-expansion-panel>
</div>
